import React, { useState } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Projects from './components/Projects';
import TimelineSection from './components/TimelineSection';
import Skills from './components/Skills';
import Contact from './components/Contact';
import Terminal from './components/Terminal';
import ThemeToggle from './components/ThemeToggle';
import MobileDock from './components/MobileDock';

const TerminalIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="4 17 10 11 4 5" />
    <line x1="12" y1="19" x2="20" y2="19" />
  </svg>
);

const App = () => {
  const [terminalOpen, setTerminalOpen] = useState(false);

  return (
    <>
      <Navbar />

      <main className="portfolio-main">
        <Hero />
        <Projects />
        <TimelineSection />
        <Skills />
        <Contact />
      </main>

      <footer className="portfolio-footer">
        <div className="container">
          <span>© {new Date().getFullYear()} Saad Beidouri — Built with React</span>
        </div>
      </footer>

      <ThemeToggle />
      <MobileDock onOpenTerminal={() => setTerminalOpen(true)} />

      {/* Terminal easter egg */}
      <button
        className="terminal-fab"
        onClick={() => setTerminalOpen(true)}
        title="Open terminal"
        aria-label="Open terminal easter egg"
      >
        <TerminalIcon />
      </button>

      {terminalOpen && (
        <div
          className="terminal-overlay"
          onClick={(e) => e.target === e.currentTarget && setTerminalOpen(false)}
        >
          <div className="terminal-modal">
            <button
              className="terminal-modal-close"
              onClick={() => setTerminalOpen(false)}
              aria-label="Close terminal"
            >
              ✕
            </button>
            <Terminal />
          </div>
        </div>
      )}
    </>
  );
};

export default App;
